import * as React from 'react'
import { Tooltip } from '@lacedltd/laced-components'
import * as S from './Checkbox.styles'

const Checkbox = ({
  inverted,
  large = false,
  textAlign = 'right',
  className,
  children,
  centeredIcon = false,
  tooltip,
  ...restProps
}: CheckboxProps) => {
  const classes = [className, 'styled-label'].join(' ')

  const checkbox = (
    <S.CheckboxLabel
      textAlign={textAlign}
      inverted={inverted}
      centeredIcon={centeredIcon}
      className={classes}
    >
      <S.CheckboxInput type="checkbox" {...restProps} />
      <Check large={large} />
      <S.CheckboxSpan>{children}</S.CheckboxSpan>
    </S.CheckboxLabel>
  )

  return tooltip?.length ? (
    <Tooltip value={tooltip}>{checkbox}</Tooltip>
  ) : (
    checkbox
  )
}

export default Checkbox

const Check = ({ large }: CheckProps) => (
  <S.CheckIcon large={large}>
    <svg
      height="8px"
      viewBox="0 0 273 220"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth="1" fillRule="evenodd">
        <S.Graphic transform="translate(-30.000000, 0.000000)">
          <polygon points="303 42 254 0 134 129 73 75 30 123 139 220" />
        </S.Graphic>
      </g>
    </svg>
  </S.CheckIcon>
)

interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  inverted?: boolean
  large?: boolean
  textAlign?: 'left' | 'right'
  centeredIcon?: boolean
  value?: any
  tooltip?: string
}

interface CheckProps {
  large: boolean
}
